import { getUser } from 'app/stores/user-store';
import {
  setEncryptedByPreferenceCookie,
  getDecrypted,
} from 'globals/storage-encrypted';
import { storageKeys, StorageKey, remove } from 'globals/storage';
import {
  DigitalClinicalProgramListItem,
  ActivityFragment,
} from 'graphql/__generated__/graphql';

function saveProgramLocally<ValueType>(
  key: StorageKey,
  value: ValueType | undefined,
) {
  if (!value) {
    remove(key);
    return;
  }

  const currentUser = getUser();

  return setEncryptedByPreferenceCookie(key, value, currentUser.user_id, true);
}

function getProgramLocally<ValueType>(key: StorageKey): ValueType | undefined {
  const currentUser = getUser();

  return getDecrypted(key, currentUser.user_id, true);
}

interface DigitalClinicalProgram
  extends Partial<DigitalClinicalProgramListItem> {
  isRecommended?: boolean;
}

export const saveNextCareNowLocally = (
  program?: DigitalClinicalProgram | null,
) => {
  const isProgramComplete =
    program?.progress?.completedModules === program?.progress?.totalModules;

  return saveProgramLocally(
    storageKeys.nextCareNowModule,
    isProgramComplete && !program?.isRecommended ? undefined : program,
  );
};

export const getNextCareNowLocally = (): DigitalClinicalProgram | undefined => {
  return getProgramLocally(storageKeys.nextCareNowModule);
};

export const saveNextCarePlanLocally = (program?: ActivityFragment) => {
  return saveProgramLocally(storageKeys.nextCarePlanModule, program);
};

export const getNextCarePlanLocally = (): ActivityFragment | undefined => {
  return getProgramLocally(storageKeys.nextCarePlanModule);
};
